<template>
  <b-overlay :show="!campaign">
    <vueCustomScrollbar
      class="scroll-area p-2"
      :settings="{wheelSpeed:0.5}"
      v-if="campaign"
    >
      <h3 class="mb-3">Campaign details</h3>
      <p>
        <b>id:</b> {{cid}}<br>
        <b>title:</b> {{campaign.data().title}}<br>
        <b>subtitle:</b> {{campaign.data().subtitle}}<br>
        <b>icon_path:</b> <a :href="campaign.data().icon_path" target="_blank">{{campaign.data().icon_path}}</a><br>
        <b>redirect_link:</b> {{campaign.data().redirect_link}}<br>
        <b>date:</b> {{campaign.data().date.toMillis() | moment('lll')}}<br><br>
        
      </p>

      <h3 class="mb-3">Video details</h3>
      <p>
        <b>id:</b> {{campaign.video.id}}<br>
        <b>title:</b> {{campaign.video.data().title}}<br>
        <b>description:</b> {{campaign.video.data().description}}<br>
        <b>VidPush_link:</b> <a :href="campaign.video.data().VidPush_link" target="_blank">{{campaign.video.data().VidPush_link}}</a><br>
        <b>frames:</b> {{campaign.video.data().frames}}<br>
        <b>video_url:</b> <a :href="campaign.video.data().video_url" target="_blank">{{campaign.video.data().video_url}}</a><br>
        <b>download_url:</b> <a :href="campaign.video.data().download_url" target="_blank">{{campaign.video.data().download_url}}</a>
      </p>
    </vueCustomScrollbar>
  </b-overlay>
</template>

<script>
import firebase from 'firebase';
import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
  name: 'campaignDetail',
  props:{
    cid:{
      type:String,
      required:true,
    }
  },
  components: {
    vueCustomScrollbar,
  },
  data:function(){
    return {
      campaign:null,
    }
  },
  watch:{
    cid:{
      handler:function() {
        let newCampaignData = null;
        this.campaign = null;
        firebase.firestore()
        .collection("campaigns")
        .doc(this.cid)
        .onSnapshot((campaign)=>{
          newCampaignData = campaign;
          firebase.firestore()
          .collection("videos")
          .doc(campaign.data().video.id)
          .onSnapshot((video)=>{
            newCampaignData.video = video;
            this.campaign = newCampaignData;
          });
        });
      },
      immediate:true,
    }
  }
}
</script>
<style scoped>
.scroll-area{
  height: 100vh !important;
}
.scroll-area.ps--active-y{
  padding-right: 12px !important;
}
p{
  word-break: break-all;
}
</style>